import { render, staticRenderFns } from "./ModelPreview.vue?vue&type=template&id=1ac685ce"
import script from "./ModelPreview.vue?vue&type=script&lang=js"
export * from "./ModelPreview.vue?vue&type=script&lang=js"
import style0 from "./ModelPreview.vue?vue&type=style&index=0&id=1ac685ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports